<div class="synopsis" *ngIf="tabHeaderInfo">
    <div class="people icon icon-key-hotel">
        <span class="room">
            <span>{{tabHeaderInfo.roomPeople.rooms}}</span>
            <span>Room</span>
        </span>
        <span class="adult">
            <span>{{tabHeaderInfo.roomPeople.adults}}</span>
            <span>Adults</span>
        </span>
        <span class="child">
            <span>{{tabHeaderInfo.roomPeople.children}}</span>
            <span>Children</span>
        </span>
    </div>
    <div class="dates">
        <div class="check">
            <span>Check-in</span>
            <span>{{tabHeaderInfo.checkin}}</span>
        </div>
        <div class="check">
            <span>Check-out</span>
            <span>{{tabHeaderInfo.checkout}}</span>
        </div>
    </div>
    <span class="nightCounter">
        <span>{{tabHeaderInfo.numberOfNights}}</span>
        <span>nights</span>
    </span>
</div>